<div class="page-height overflow-auto bg-panel">
  @if (LoadDashboard()) {
    <odin-dashboard-metrics></odin-dashboard-metrics>
  }
  <odin-announcement-display
    data-test="dashboard-announcements"
  ></odin-announcement-display>

  <!--  <div class="align-self-end w-100" *ngIf="pciEnabled()">-->
  <!--    <odin-pci-widget></odin-pci-widget>-->
  <!--  </div>-->
</div>
